import _ from "lodash";


import state from "../state";
import env from "../constants/env";

export const RESOURCE_REFERENCE = "resource/ref";

/**
 * Call this to initialize the drive when the component mounts
 * @param {*} drive 
 */
export function initializeDrive(drive) {
	state.set(["drive"], drive);
}

export function isDriveReference(obj) {
	return obj && obj.hasOwnProperty("type") && obj.type === RESOURCE_REFERENCE;
}

export function getUrlForValue2(value) {
    return value;
}

function getActivityOrCurrentlySelected() {
	return state.get(["activity"]);
}

export function isResourceReference(obj) {
	return obj && obj.hasOwnProperty("type") && (obj.type === RESOURCE_REFERENCE || obj.type === "datasource-ref");
}

function getResource(id, activity) {
	let result = null;
	if (!activity) {
		activity = getActivityOrCurrentlySelected();
	}
	if (activity) {
		_.forEach(activity.externalResources, extResource => {
			if (extResource.id === id) {
				result = extResource;
			}
		});
	}
	return result;
}

export function getResourceForReference(ref, activityIdorActivity = null) {
	const { refId } = ref;
	// Get the current activity
	const activity = _.isPlainObject(activityIdorActivity) ? activityIdorActivity : getActivityOrCurrentlySelected(activityIdorActivity);
	console.log("Web Player: Got activity for resource reference resolution", activity, ref);
	if (activity) {
		return getResource(refId, activity);
	} else {
		throw new Error("No activity is currently selected.");
	}
}

export function getExternalResourceInfos(drive=null) {
	console.log("Web Player: Get external resource infos", drive);
	let guidToResource = state.get(["drive", "guidToResource"]);
	if (!guidToResource && drive.guidToResource) {
		guidToResource = drive.guidToResource;
	}
	return guidToResource;
}

export function getExternalResourceInfo(guid, drive=null) {
	const resourceInfos = getExternalResourceInfos(drive);
	let result = null;
	if (resourceInfos[guid]) {
		result = resourceInfos[guid];
	}
	return result;
}

export function getUrlForResource(resource,drive=null,env=null) {
	const externalResource = getExternalResourceInfo(resource.guid, drive);
	if (externalResource) {

		return getUrlForExternalResource(externalResource,env);

	} else {
		throw new Error(`Unable to find external resoruce for guid ${resource.guid}`);
	}
}

export function getUrlForExternalResource(externalResource, _env=null) {
	
	let targetEnv = _env;
	if (!targetEnv) {
		targetEnv = env;
	}
	console.log("Web Player: getUrlForExternalResource", _env);
	const urlPrefix = (externalResource.private) ? targetEnv.cloudFront.assetUrls.private : targetEnv.cloudFront.assetUrls.public;
	if (externalResource.path && externalResource.path.replace) {
		return `${urlPrefix}/${externalResource.path.replace(/^public\//, "").replace(/^private\//, "")}?v=${externalResource.revision}`;
	} else {
		return "";
	}
}

export function getUrlForValue(value, activityId = null, drive, env) {
	let result = value;
	console.log("Web Player: Get Url For Value", value, activityId);
	if (!_.isString(value) && isDriveReference(value)) {
		console.log("Web Player: Get Url For Value - Is Drive Reference", value, activityId);
		try {
			// console.log("PLAYER: Got drive reference", value);
			const expandedValue = getResourceForReference(value, activityId);
			console.log("Web Player: Got drive reference expanded value", expandedValue);
			result = getUrlForResource(expandedValue, drive, env);
			console.log("Web Player: Resolved drive reference", result);
		} catch (err) {
			console.warn(err);
		}
	}

	return result;
}


export function getResourceContentForResourceRef(activity, ref) {
	return new Promise((resolve, reject) => {
		if (!activity) {
			activity = state.get(["activity"]);
		}
		let targetUrl = getUrlForValue(ref, activity.id);

		// const targetUrl = downloadRequest && downloadRequest.hasOwnProperty("noCacheUrl") ? downloadRequest.noCacheUrl : downloadRequest.url;

		// console.log("About to fetch", targetUrl);

		if (_.isString(targetUrl) && targetUrl.indexOf("assets/") === 0) {
			targetUrl = window.location.href.replace("/index.html", "") + "/" + targetUrl;
		}
		fetch(targetUrl, {
			credentials: "include"
		})
			.then(res => {
				if (res.status === 200) {
					resolve(res.json());
				} else {
					console.error(`Request failed with status code ${res.status}`, res.statusText);
					reject(`Request failed with status code ${res.status}`);
				}
			}).catch(err => {
				console.error(err);
				reject(err);
			});


		// downloadResources([downloadRequest], {
		// 	attemptParsedResults: true, noCache: true
		// }).then(results => {
		// 	resolve(results[0]);
		// }).catch(err => {
		// 	console.error(err);
		// 	reject(err);
		// })
	});
}